// extracted by mini-css-extract-plugin
module.exports = {"card":"ErrorQuery-module__card___2N1ZO","results":"ErrorQuery-module__results___2Ynm9","result":"ErrorQuery-module__result___2vICE","sql":"ErrorQuery-module__sql___178aq"};